import { SsoUser } from '@usana/ux/sso-auth';

export abstract class AnalyticsService {
  abstract trackEvent(eventName: string, eventData?: any): void;

  abstract informOfUser(ssoUser: SsoUser): void;
  abstract informOfIdToken(idToken: string): void;
  abstract localizeEventData(eventDataName: string): string;
}
